// should match AuditSuggestionEnrichment.java
export enum SuggestionType {
	SENTIMENT = 'sentiment',
	EFFORT = 'easeScore',
	EMOTION = 'emotion',
	TOPIC = 'topic'
}